<template>
  <div>
    <v-container class="py-10">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <h2>23. Cloud-Nutzung und Datenschutz</h2>
          <p></p>
          <p style="color: green">
            <b>UPDATE</b>
          </p>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "CloudUse4",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "column"
        },
        title: {
          text:
            "Bitte beurteilen Sie, wie sich die Nutzung von Cloud-Lösungen​ Ihrer Meinung nach auf den Datenschutz auswirkt."
        },
        plotOptions: {
          series: {
            dataLabels: {
              useHTML: true,
              enabled: true,
              formatter: function() {
                return this.series.marker;
              }
            }
          }
        },
        xAxis: {
          categories: [
            "Sehr negativ",
            "Negativ",
            "Weder, noch",
            "Positiv",
            "Sehr positiv"
          ]
        },
        yAxis: {
          min: 0,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        tooltip: {
          valueSuffix: "%"
        },
        colors: ["#546825"],
        series: [
          {
            showInLegend: false,
            name: "",
            data: [6.2, 29.1, 43.8, 12.4, 8.5]
          }
        ],
        exporting: {
          enabled: true,
          fallbackToExportServer: false
        }
      };
    }
  },
  methods: {
    downloadJPEG() {
      this.$refs.chart.chart.exportChart({ type: "image/jpeg" });
    },
    downloadSVG() {
      this.$refs.chart.chart.exportChart({ type: "image/svg+xml" });
    },
    downloadPDF() {
      this.$refs.chart.chart.exportChart({ type: "application/pdf" });
    },
    downloadCSV() {
      this.$refs.chart.chart.downloadCSV();
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
